import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $hasBorderBottom: boolean;
  $hasPadding: boolean;
}>`
  ${({ $hasPadding }) =>
    $hasPadding &&
    css`
      padding: 10px 15px;
    `}

  ${({ $hasBorderBottom }) =>
    $hasBorderBottom &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
    `}
  
  background-color: ${({ theme }) => theme.palette.primary.background};
  margin-bottom: 10px;
`;

export const CategoryWithCountText = styled.p`
  font-size: 16px;
  text-wrap: wrap;
  white-space: pre-line;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const AdsCountLabel = styled.span`
  margin-left: 5px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;
